import { Link } from "react-router-dom";
import { films, genres } from "@/mocks/films";

const genreCounts = genres.map((genre) => {
  const count = films.filter((film) => film.genres.includes(genre)).length;
  return { genre, count };
});

const GenreGrid = () => (
  <section id="genres" className="w-full bg-background-50">
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-10">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {genreCounts.map(({ genre, count }) => (
          <Link
            key={genre}
            to={`/category?genre=${encodeURIComponent(genre)}`}
            className="group flex items-center justify-between rounded-lg border border-background-200/80 bg-background-100/70 px-3.5 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex items-center gap-2">
              <span className="flex h-1.5 w-1.5 rounded-full bg-accent-500" />
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                {genre}
              </span>
            </span>
            <span className="text-[11px] text-foreground-400">{count} 部</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default GenreGrid;